import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import AuthStore from "../store/AuthStore";

export const useAuthStore = (): AuthStore => {
    const { authStore } = useContext(AuthContext);
    return authStore;
}

